import React from 'react';
import { createPortal } from 'react-dom';
import styles from '../AdminUserCfpSessions.module.css';
import { displayText } from './helpers';

export function MarkSessionDoneModal({ session, submitting, error, onClose, onConfirm }) {
  if (!session || typeof document === 'undefined') return null;

  return createPortal(
    <div className={styles['confirm-overlay']} role="presentation" onClick={onClose}>
      <div
        className={styles['confirm-dialog']}
        role="dialog"
        aria-modal="true"
        aria-labelledby="admin-cfp-session-done-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className={styles['confirm-icon']} aria-hidden>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 11l3 3L22 4" />
            <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" />
          </svg>
        </div>
        <h2 id="admin-cfp-session-done-title" className={styles['confirm-title']}>
          Mark session as done?
        </h2>
        <p className={styles['confirm-text']}>
          Are you sure you want to mark this CFP session as done for{' '}
          <strong>{displayText(session?.user_name, 'this user')}</strong>?
          This cannot be undone.
        </p>
        {error && (
          <div className={styles['confirm-error']} role="alert">
            {error}
          </div>
        )}
        <div className={styles['confirm-divider']} aria-hidden />
        <div className={styles['confirm-actions']}>
          <button
            type="button"
            className={styles['confirm-cancel']}
            onClick={onClose}
            disabled={submitting}
          >
            Cancel
          </button>
          <button
            type="button"
            className={styles['confirm-submit']}
            onClick={onConfirm}
            disabled={submitting}
            aria-busy={submitting}
          >
            {submitting ? 'Saving…' : 'Yes, mark as done'}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
